import React from 'react'
import { Card } from 'antd'
import { useParams } from 'react-router'
import DistributionBetweenPhasesChart from './DistributionBetweenPhasesChart'

const DistributionBetweenPhasesCard = ({ title = 'Distribution Between Phases', phasesToShow }) => {
    const { token } = useParams()
    return (
        <Card title={title}>
            <DistributionBetweenPhasesChart token={token} phasesToShow={phasesToShow} />
        </Card>
    )
}

export default DistributionBetweenPhasesCard
